export const DEFAULT_LANG = 'en';
export const ALL_LANGS = ['en'] as const;
export const AUTHOR_NAME = 'Katy Jane';
export const DEFAULT_CURRENT_YEAR = 2023;

export const DEFAULT_SITE_DOMAIN = 'vedicmoonsigns.com';
export const DEFAULT_SITE_BASE_URL = 'https://www.vedicmoonsigns.com';

export const SITE_DOMAIN =
  process.env.NODE_ENV === 'development'
    ? 'localhost:8000'
    : process.env.GATSBY_SITE_DOMAIN || DEFAULT_SITE_DOMAIN;

export const SITE_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8000'
    : process.env.GATSBY_SITE_BASE_URL || DEFAULT_SITE_BASE_URL;

export const MAX_OG_DESCRIPTION_LENGTH = 300;

export const GOOGLE_OPTIMIZE_ID = process.env.GATSBY_GOOGLE_OPTIMIZE_ID;
export const SHOULD_RUN_GOOGLE_OPTIMIZE =
  process.env.NODE_ENV === `production` && !!GOOGLE_OPTIMIZE_ID;

export const GOOGLE_PLACES_API_KEY = process.env.GATSBY_GOOGLE_PLACES_API_KEY;
